import {
  TypedSunovationDispatch,
  TypedSunovationState,
} from '../sunovationStore'
import { selectOrderDialogOpenState } from './orderDialogSelectors'
import { setOrderDialogState } from './orderDialogSlice'

export const updateOrderDialogOpenState =
  (openState: boolean) =>
  (dispatch: TypedSunovationDispatch, getState: () => TypedSunovationState) => {
    const oldOpenState = selectOrderDialogOpenState(getState())
    if (openState !== oldOpenState) {
      dispatch(setOrderDialogState(openState))
    }
  }
